import React from 'react';
import PropTypes from 'prop-types';
import MarkAsUrgentCheckbox from 'common/components/MarkAsUrgentCheckbox';
import { useUpdateServiceAuthorization } from '../hooks/useUpdateServiceAuthorization';

const MarkAuthorizationAsUrgentCheckbox = ({ authorizationId, isUrgent }) => {
  const updateServiceAuthorization = useUpdateServiceAuthorization();

  return (
    <MarkAsUrgentCheckbox
      id={authorizationId}
      checked={isUrgent}
      onUpdate={updateServiceAuthorization}
    />
  );
};

MarkAuthorizationAsUrgentCheckbox.propTypes = {
  authorizationId: PropTypes.string.isRequired,
  isUrgent: PropTypes.bool,
};

MarkAuthorizationAsUrgentCheckbox.defaultProps = {
  isUrgent: undefined,
};

export default MarkAuthorizationAsUrgentCheckbox;
